import { Form, Select, Switch } from 'antd'
import DeleteIcon from 'components/icons/Delete'
import { FormItem } from 'components/Select'
import {
  AddLinkspan,
  AddMediaButton,
} from 'modules/Settings/Components/AddtionalInfo/style'
import React, { useContext } from 'react'
import AddBlueBorderIcon from '../../../../../../components/icons/AddBlueBorderIcon'
import ArrowDownIcon from '../../../../../../components/icons/ArrowDownIco'
import { EmptyDivElement } from '../../../../../../components/UIComponents/CommonStyledComponent'
import { allMonths } from '../../../RuleEngineCommonFunction'
import { RuleContext } from '../../RulesCreationTable'
import { RangeContainer, StyledRuleCol, StyledRuleRow } from '../../style'
import {
  StyledBoldTextOne,
  StyledInput,
  TextContainer,
  TextLine,
} from '../CTCDrawers/style'
import StyledSelect, { StyledFormItem } from './style'

const TenureDrawer = () => {
  const { ruleForm, setState, state, selectedRuleDrawer } =
    useContext(RuleContext)
  const jobCategoryType = selectedRuleDrawer?.category
  const title = `Maximum ${jobCategoryType} Duration`
  const duration = ruleForm.getFieldValue([jobCategoryType, 'duration'])
  const tenureRange = ruleForm.getFieldValue([jobCategoryType, 'tenureRange'])
  const hasTenureRange = state[jobCategoryType]?.tenureRange?.some(
    item => item?.isEnabled
  )
  const isEnable = tenureRange.some(
    item => item.isEnabled && item.endMonth && item.startMonth
  )
  const handleDurationChange = e => {
    let newDuration = parseInt(e.target.value, 10)
    if (newDuration > 12 || newDuration <= 0) newDuration = duration
    ruleForm.setFieldValue([jobCategoryType, 'duration'], newDuration)
    const currentRange =
      ruleForm.getFieldValue([jobCategoryType, 'tenureRange']) || []
    for (let [index, range] of currentRange.entries()) {
      const startMonth = range?.startMonth
      const startMonthIndex = allMonths.indexOf(startMonth)
      if (startMonthIndex >= 0) {
        const endMonthIndex = (startMonthIndex + Number(newDuration) - 1) % 12
        range.endMonth = endMonthIndex >= 0 ? allMonths[endMonthIndex] : null
      }
      if (index === 0 && !range.startMonth && !range.endMonth) {
        range.isEnabled = true
      }
    }
    setState(prevState => ({
      ...prevState,
      [jobCategoryType]: {
        ...prevState[jobCategoryType],
        tenureRange: currentRange,
        duration: newDuration,
        // isEnabled: newDuration ? isEnable : false,
      },
    }))
  }

  const handleRemoveRange = (remove, index) => {
    remove(index)
  }

  const handleChange = (value, index, fieldName) => {
    const startMonthIndex = allMonths.indexOf(value)
    let endMonth = null
    if (startMonthIndex >= 0) {
      const endMonthIndex = (startMonthIndex + Number(duration) - 1) % 12
      endMonth = allMonths[endMonthIndex]
    }

    ruleForm.setFieldValue(
      [jobCategoryType, 'tenureRange', index, fieldName],
      value || ''
    )

    if (fieldName === 'startMonth') {
      if (value == undefined) {
        ruleForm.setFieldValue(
          [jobCategoryType, 'tenureRange', index, 'startMonth'],
          value
        )
      }
      value = value == undefined ? null : value
      ruleForm.setFieldValue(
        [jobCategoryType, 'tenureRange', index, 'endMonth'],
        endMonth
      )
    }
    if (fieldName === 'isEnabled' && value == '') {
      value = false
    }

    const currentRange =
      ruleForm.getFieldValue([jobCategoryType, 'tenureRange']) || []
    const updatedRange = currentRange.map((item, idx) => {
      if (idx === index) {
        return {
          ...item,
          [fieldName]: value,
          endMonth: fieldName === 'startMonth' ? endMonth : item.endMonth,
        }
      }
      return {
        ...item,
        isEnabled: item?.isEnabled || false,
      }
    })

    // Update state with the modified tenureRange array
    setState(prevState => ({
      ...prevState,
      [jobCategoryType]: {
        ...prevState[jobCategoryType],
        tenureRange: updatedRange,
        // isEnabled: updatedRange?.some(item => item.isEnabled) ? true : false,
        activeTenureRange: updatedRange?.some(item => item && item?.isEnabled),
      },
    }))
  }
  const getAvailableMonths = currentIndex => {
    const selectedMonths = ruleForm
      .getFieldValue([jobCategoryType, 'tenureRange'])
      .map((item, idx) => (idx !== currentIndex ? item?.startMonth : null))
      .filter(Boolean)

    return selectedMonths
  }

  const handleAddRange = add => {
    const newRange = { isEnabled: false, startMonth: null, endMonth: null }
    add(newRange)
  }

  return (
    <>
      <TextContainer>
        <TextLine style={{ fontSize: '14px' }}>
          This rule determines the number of months of{' '}
          {jobCategoryType === 'internship'
            ? 'internship '
            : jobCategoryType === 'apprenticeship'
            ? 'apprenticeship '
            : 'Gigs '}
          that the college permits students to undertake and specifies the
          periods of the year during which these internships can occur,
          specifically for roles from PIL. It is important to note that roles
          from this tenure will be auto-approved.
        </TextLine>
      </TextContainer>

      <StyledRuleRow pTop={25}>
        <StyledRuleCol md={6}>
          <StyledBoldTextOne>{title}</StyledBoldTextOne>
        </StyledRuleCol>
        <StyledRuleCol>
          <Form.Item
            name={[jobCategoryType, 'duration']}
            rules={[
              () => ({
                validator(_, value) {
                  if (!value) {
                    return Promise.reject(
                      new Error(`Please enter the duration`)
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledInput
              type="number"
              min={1}
              max={12}
              value={duration}
              onChange={handleDurationChange}
              addonAfter="months"
              placeholder="0"
            />
          </Form.Item>
        </StyledRuleCol>
      </StyledRuleRow>
      <StyledRuleRow pTop={25}>
        <StyledBoldTextOne>Tenure range &nbsp;</StyledBoldTextOne>
        {!hasTenureRange && (
          <>
            {' '}
            <StyledBoldTextOne>| &nbsp;</StyledBoldTextOne>
            <StyledBoldTextOne red>
              {' '}
              At least, Activate any one duration period
            </StyledBoldTextOne>
          </>
        )}
      </StyledRuleRow>
      <br />

      <FormItem
        name={jobCategoryType}
        initialValues={{
          [jobCategoryType]: state?.[jobCategoryType],
        }}
      >
        <Form.List name={[jobCategoryType, 'tenureRange']}>
          {(fields, { add, remove }) => (
            <div>
              {fields.map((field, index) => (
                <RangeContainer key={field.key}>
                  <StyledFormItem
                    {...field}
                    name={[field.name, 'isEnabled']}
                    valuePropName="checked"
                    style={{
                      display: 'inline-block',
                      marginTop: 10,
                    }}
                    inputWidth={'132px'}
                  >
                    <Switch
                      onChange={value =>
                        handleChange(value, index, 'isEnabled')
                      }
                    />
                  </StyledFormItem>
                  <TextContainer style={{ marginTop: 14 }}>From</TextContainer>
                  <StyledFormItem
                    {...field}
                    name={[field.name, 'startMonth']}
                    style={{ display: 'inline-block', width: '132px' }}
                    rules={[
                      () => ({
                        validator(_, value) {
                          if (duration && !value) {
                            return Promise.reject(
                              new Error(`Please select the month`)
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                    inputWidth={'132px'}
                  >
                    <StyledSelect
                      suffixIcon={<ArrowDownIcon />}
                      allowClear
                      onChange={value =>
                        handleChange(value, index, 'startMonth')
                      }
                      placeholder="Select month"
                      disabled={!duration}
                    >
                      {allMonths.map((month, index) => (
                        <Select.Option
                          key={month + index}
                          value={month}
                          disabled={getAvailableMonths(field.name)?.includes(
                            month
                          )}
                        >
                          {month}
                        </Select.Option>
                      ))}
                    </StyledSelect>
                  </StyledFormItem>
                  <TextContainer style={{ marginTop: '10px' }}>
                    To
                  </TextContainer>
                  <StyledFormItem
                    {...field}
                    name={[field.name, 'endMonth']}
                    style={{ display: 'inline-block', width: '132px' }}
                    rules={[
                      ({ getFieldValue }) => ({
                        validator(_, value) {
                          const startMonth = getFieldValue([
                            jobCategoryType,
                            'tenureRange',
                            field.name,
                            'startMonth',
                          ])
                          const startMonthIndex = allMonths.indexOf(startMonth)
                          const endMonthIndex =
                            (startMonthIndex + Number(duration) - 1) % 12
                          const endMonth = allMonths[endMonthIndex]
                          if (duration && !value) {
                            return Promise.reject(
                              new Error(`Please select the month`)
                            )
                          }
                          if (value && value !== endMonth) {
                            return Promise.reject(
                              new Error('Please select the valid month')
                            )
                          }
                          return Promise.resolve()
                        },
                      }),
                    ]}
                    inputWidth={'132px'}
                  >
                    <StyledSelect
                      suffixIcon={<ArrowDownIcon />}
                      placeholder={'Select month'}
                      disabled={!duration}
                    >
                      {allMonths.map((month, index) => (
                        <Select.Option key={month + index} value={month}>
                          {month}
                        </Select.Option>
                      ))}
                    </StyledSelect>
                  </StyledFormItem>
                  {/* Display error if exists */}
                  {fields.length > 1 && (
                    <AddMediaButton
                      text={
                        <EmptyDivElement
                          onClick={() => handleRemoveRange(remove, field.name)}
                        >
                          <DeleteIcon />
                        </EmptyDivElement>
                      }
                    />
                  )}
                  {/* Button to remove the field */}
                </RangeContainer>
              ))}
              <AddMediaButton
                text={<AddLinkspan>Add another range</AddLinkspan>}
                icon={<AddBlueBorderIcon />}
                onClick={() => handleAddRange(add)}
                disabled={
                  ruleForm.getFieldValue([jobCategoryType, 'tenureRange'])
                    ?.length >= 12
                }
              />
              {/* Button to add a new field */}
            </div>
          )}
        </Form.List>
      </FormItem>
    </>
  )
}

export default TenureDrawer
